import { connect } from 'react-redux';

import SnackBarProductAdd from '../../components/SnackBarProductAdd';

const mapStateToProps = ({ cart: { addSuccess, addError }, app }) => ({
  addSuccess,
  addError,
  isMobile: app.getIn(['plataform']) === 'mobile',
});

export default connect(mapStateToProps)(SnackBarProductAdd);
